module.exports = __webpack_public_path__ + "img/roadmap.bdddfc47.png";